import { IconButton, SxProps, Theme } from '@mui/material';
import { HelpOutline } from '@mui/icons-material';
import { FC } from 'react';
import { EasTooltip } from 'ui/EasTooltip';
import { EHelpButtonArticles, HELP_CENTER_ARTICLE_URLS } from './constants';

type THelpButtonProps = {
	type: EHelpButtonArticles;
	sx?: SxProps<Theme>;
};

// Opens the Help Center article about the page in a new tab
export const HelpButton: FC<THelpButtonProps> = ({ type, sx }) => (
	<EasTooltip title={`Help - ${type}`}>
		<IconButton
			color="primary"
			sx={{ fontSize: '2rem', p: 0, m: 0, ...sx }}
			onClick={() => window.open(HELP_CENTER_ARTICLE_URLS[type], '_blank', 'noopener,noreferrer')}
		>
			<HelpOutline sx={{ fontSize: '2rem', p: 0, m: 0, ...sx }} />
		</IconButton>
	</EasTooltip>
);
